import { STATUS } from '../../constants/commonConstants';

export const footerInitialStore = {
  changeLanguageStatus: STATUS.IDLE,
  supportedLanguages: [],
  getLanguageStatus: STATUS.IDLE,
  socialMediaLinks: [],
  getSocialMediaLinkStatus: STATUS.IDLE
};
